import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import ImageUpload from "./ImageUpload";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "react-toastify";

const AddCategoryModal = ({ show, handleClose, onSuccess }) => {
    const { user } = useAuth();
    const [form, setForm] = useState({ name: "", image: null });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            setForm({ name: "", image: null });
        }
    }, [show]);

    const handleFormChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No authentication token found");

            const response = await fetch("/api/categories", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    "X-Owner-Id": String(user?.ownerId || user?.id || ""),
                    "X-Staff-Id": String(user?.staffId ?? ""),
                },
                body: JSON.stringify({
                    ...form,
                    owner_id: user.role === "owner" ? user.id : user.owner_id,
                }),
            });

            if (!response.ok) throw new Error("Operation failed");

            const responseData = await response.json();
            toast.success("Kategoriya muvaffaqiyatli qo'shildi");
            if (onSuccess) onSuccess(responseData);
            handleClose();
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Kategoriya qo'shish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Nomi</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={handleFormChange}
                            required
                            placeholder="Kategoriya nomini kiriting"
                        />
                    </Form.Group>
                    <div className="mb-3">
                        <ImageUpload
                            label="Kategoriya rasmi (300x300)"
                            initialImage={null}
                            onUpload={(path) => setForm((prev) => ({ ...prev, image: path }))}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} disabled={loading}>
                        Bekor qilish
                    </Button>
                    <Button variant="success" type="submit" disabled={loading}>
                        {loading ? "Saqlanmoqda..." : "Saqlash"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default AddCategoryModal;
